
import { Component, Vue } from 'vue-property-decorator';

import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/List.vue';

import PatientsModule from '@/store/patients';
import UserModule from '@/store/user';

@Component({
    components: {
        Layout,
        ListBlock,
    }
})
export default class PatientsPage extends Vue {
    repository = PatientsModule;
    isDoctor = UserModule.isDoctor;

    get filterSettings() {
        return PatientsModule.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'patients_create' });
    }

    async updateList() {
        await this.repository.filter.updateFilter();
        await this.repository.updatePage('1');
    }

    async resetFilters() {
        await this.repository.clearSort();
        await this.repository.filter.resetFilter();
        await this.repository.updatePage('1');
    }
}
